import React from "react";
import { ArrowRight, History } from "lucide-react";
import { fmtD, fmtDT } from "../../lib/date";

const VIA = { org_editor: ["组织架构编辑器", "Org editor"], employee_edit: ["员工档案编辑", "Profile edit"] };

/* 员工组织调动履历：入职起点 + 每次 法人/部门/岗位 变更（谁、何时、从哪→到哪） */
export const EmpTransferHistory = ({ detail, zh, brZh, roleZh, DP }) => {
  const T = (a, b) => (zh ? a : b);
  const hist = [...(detail.orgHistory || [])].sort((a, b) => (b.at || "").localeCompare(a.at || ""));
  const seg = (s) => `${brZh(s.branch) || "-"} / ${DP[s.department] || s.department || "-"} / ${roleZh(s.role) || "-"}`;
  const first = hist.length ? hist[hist.length - 1].from : { branch: detail.branch, department: detail.department, role: detail.role };
  return (
    <div data-testid="hrms-emp-history">
      <p className="text-xs font-bold text-slate-600 flex items-center gap-1.5 mb-1.5"><History className="h-3.5 w-3.5" />{T(`组织调动履历（${hist.length} 次）`, `Transfer history (${hist.length})`)}</p>
      <div className="rounded-lg border border-slate-100 divide-y divide-slate-50 max-h-48 overflow-y-auto">
        {hist.map((h, i) => (
          <div key={i} className="px-3 py-1.5 text-[11px] flex flex-wrap items-center gap-x-2 gap-y-0.5" data-testid={`hrms-emp-history-${i}`}>
            <span className="text-slate-400 w-28 shrink-0">{fmtDT(h.at)}</span>
            <span className="text-slate-500 line-through decoration-slate-300">{seg(h.from)}</span>
            <ArrowRight className="h-3 w-3 text-indigo-500" />
            <span className="font-semibold text-slate-700">{seg(h.to)}</span>
            <span className="ml-auto text-slate-400">{h.by || "-"}{h.via ? ` · ${zh ? VIA[h.via]?.[0] || h.via : VIA[h.via]?.[1] || h.via}` : ""}</span>
          </div>
        ))}
        <div className="px-3 py-1.5 text-[11px] flex flex-wrap items-center gap-x-2 text-slate-500" data-testid="hrms-emp-history-hire">
          <span className="text-slate-400 w-28 shrink-0">{fmtD(detail.hireDate) || "-"}</span>
          <span>{T("入职", "Hired")} · {seg(first)}</span>
        </div>
      </div>
    </div>
  );
};
